<app-navbar></app-navbar>

<div class="container-fluid mt-4">
  <router-outlet></router-outlet>
</div>
